import { render, staticRenderFns } from "./biscuit.vue?vue&type=template&id=081b49da&scoped=true&"
import script from "./biscuit.vue?vue&type=script&lang=js&"
export * from "./biscuit.vue?vue&type=script&lang=js&"
import style0 from "./biscuit.vue?vue&type=style&index=0&id=081b49da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b49da",
  null
  
)

export default component.exports